import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`

  const transformOrigin = '5.345 9.335'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M10.69 14.25C10.69 13.75 7.21 9.01994 6.58 0.939941H4.11C3.49 9.02994 0 13.76 0 14.25C0 14.74 4.55 17.73 5.33 17.73C6.11 17.73 10.69 14.74 10.69 14.25Z"
          fill={`url(#${randomGradientId1})`}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="5.3483"
            y1="2.65015"
            x2="5.3483"
            y2="17.6753"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8488" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
